import { render, staticRenderFns } from "./prdHistorico.vue?vue&type=template&id=7eb794e6&scoped=true&"
import script from "./prdHistorico.vue?vue&type=script&lang=js&"
export * from "./prdHistorico.vue?vue&type=script&lang=js&"
import style0 from "./prdHistorico.vue?vue&type=style&index=0&id=7eb794e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb794e6",
  null
  
)

export default component.exports